import { slugify } from "@app/layouts/Article/StorylineElements/utils";

import { ResolvedCUEElement, ResolvedSubHeadingCUEElement } from "../elements";

const TOC_HTML_ANCHORS = ["x-mag-table-of-contents", "x-mag-toc"];

export function isSubHead(
  element: ResolvedCUEElement,
): element is ResolvedSubHeadingCUEElement {
  return element.type === "sub_head";
}

/**
 * Checks if element is the special "marker" which initiates Table Of Contents.
 */
export function isTocHeader(element: ResolvedSubHeadingCUEElement) {
  const anchor = element.additionalFields.htmlAnchor?.value;
  return !!anchor && TOC_HTML_ANCHORS.includes(anchor);
}

/**
 * Checks if element is a valid list item for the Table Of Contents.
 * If TRUE, it will be a clickable entry in the TOC.
 *
 * A valid TOC item must meet all the following conditions:
 * - It must be a sub-heading element.
 * - It must be an `h2` heading level.
 * - It must NOT be the special "marker" itself.
 */
export function isTocItem(
  element: ResolvedCUEElement,
): element is ResolvedSubHeadingCUEElement {
  return (
    isSubHead(element) &&
    element.additionalFields.headings?.value === "h2" &&
    !isTocHeader(element)
  );
}

// Extract the anchor from the subhead element. Auto generate from text if missing.
export function extractAnchor(element: ResolvedSubHeadingCUEElement) {
  return (
    element.additionalFields.htmlAnchor?.value ||
    (element.additionalFields.subhead?.value &&
      slugify(element.additionalFields.subhead.value))
  );
}

export function getTableOfContentsItems(allElements: ResolvedCUEElement[]) {
  return allElements.filter(isTocItem);
}
